import React from "react";
import { Typography, makeStyles, ListItem, List } from "@material-ui/core";
import { AddTwilioInvoiceFile, GetTwilioInvoiceDateResponseList } from "../../services/api/twilioInvoice.api";
import { UploadCSVDialog } from "../../components/InvoiceProcessing/UploadCSVDialog";
import { MessageCard } from "../../components/MessageCard";
import { InvoiceDateResponse } from "../../models/Invoice";
import { Fetcher } from "../../components/Fetcher";
import { InvoiceHistoryDisplayCard } from "../../components/InvoiceProcessing/InvoiceHistoryDisplayCard";

interface TwilioInvoicePageProps {
	productId: string;
}

const useStyles = makeStyles((theme) => ({
	titleWrapper: {
		maxWidth: theme.breakpoints.values.md,
		display: "flex",
		justifyContent: "space-between",
	},
	title: {
		marginBottom: theme.spacing(3),
	},
	list: {
		maxWidth: theme.breakpoints.values.md,
	},
	addFileButton: {
		marginRight: theme.spacing(2),
	},
}));

const renderPage = (data: InvoiceDateResponse[], productId: string, classes: Record<any, string>) => {
	return (
		<div data-testid="invoice-date-list">
			{data && data.length > 0 ? (
				<div>
					<List className={classes.list}>
						{data.map((invoice) => (
							<ListItem key={invoice.invoiceDate.toString()} data-testid="invoice-list-item">
								<div>
									<InvoiceHistoryDisplayCard invoiceHistory={invoice} productId={productId}></InvoiceHistoryDisplayCard>
								</div>
							</ListItem>
						))}
					</List>
				</div>
			) : (
				<MessageCard message="No Invoices found." textAlign="left" />
			)}
		</div>
	);
};

/**
 * This page is used to display twilio invoice history date sets.
 * @param props
 */
export const TwilioInvoicesPage = (props: TwilioInvoicePageProps) => {
	const classes = useStyles();
	const [update, setUpdate] = React.useState(false);

	const forceUpdate = () => {
		setUpdate(!update);
	};

	return (
		<div data-testid="twilio-invoice-page">
			<div className={classes.titleWrapper}>
				<Typography className={classes.title} variant="h4" data-testid="twilio-invoices-page">
					Twilio Invoices
				</Typography>
				<div>
					<div className={classes.addFileButton} data-testid="add-file-button">
						<UploadCSVDialog
							productId={props.productId}
							processFile={AddTwilioInvoiceFile}
							title={"Upload Twilio Invoice File"}
							label={"Upload Invoice File"}
							forceUpdate={forceUpdate}
						></UploadCSVDialog>
					</div>
				</div>
			</div>
			<Fetcher action={GetTwilioInvoiceDateResponseList(props.productId)}>
				{(response) => renderPage(response && response.data, props.productId, classes)}
			</Fetcher>
		</div>
	);
};
